import { useAuthStore } from "~/store/auth";
import { NewFLowStep, UserType } from "~/models/enums";
import navigateAfterLogin from "~/utils/functions/navigate-after-login";

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  const { $api } = useNuxtApp();
  const accessToken = authStore.getToken();

  if (to.meta.layout === "auth") {
    if (accessToken) {
      authStore.parseToken(accessToken);
      if ([UserType[UserType.Parent], UserType[UserType.Student]].includes(authStore.role)) {
        try {
          const response = await $api.api.directUserProfileList({
            headers: {
              Authorization: `Bearer ${accessToken}`,
            }
          });

          if (response.data.canSeeNewFlow) {
            return navigateAfterLogin(response.data.step || NewFLowStep.Introduction);
          }

        } catch (err) {
        }
      }
      return navigateAfterLogin(NewFLowStep.Dashboard)
    }
  } else {
    if (!accessToken) {
      return navigateTo(`/new/sign-in?return_to=${to.path}`);
    } else {
      authStore.parseToken(accessToken);
    }
  }
})
